/**
 * Sticky helpers for /audio/temp/* — local chunks live on one pod disk.
 * Always send sessionId as a query param (nginx upstream-hash-by) and header.
 */
export function audioTempSessionKey(sessionId) {
  return String(sessionId || "nosession");
}

/**
 * Merge axios config so temp-audio requests stick to one backend instance.
 * @param {string} sessionId
 * @param {import('axios').AxiosRequestConfig} [config]
 */
export function withAudioTempSticky(sessionId, config = {}) {
  const sid = audioTempSessionKey(sessionId);
  return {
    ...config,
    params: {
      ...(config.params || {}),
      sessionId: sid,
    },
    headers: {
      ...(config.headers || {}),
      "X-Audio-Session-Id": sid,
    },
  };
}

/** Build /audio/temp/chunk-file URL with sessionId for <audio src> (hash-by query). */
export function audioTempChunkFileUrl(apiBase, { sessionId, patientId = "", filename }) {
  const base = (apiBase || "").replace(/\/$/, "");
  const params = new URLSearchParams({
    sessionId: audioTempSessionKey(sessionId),
    patientId: patientId == null ? "" : String(patientId),
    filename: String(filename || ""),
  });
  return `${base}/audio/temp/chunk-file?${params.toString()}`;
}
